define(['./utils', 'endpoints', 'security', '../requester/urlBuilder', 'http'],
    function(utils, endpoints, security, urlBuilder, http) {
        var maxNoOfItemsForSyncBatchRequest = 100;
        var defaultConfiguration = {
            queryRequired: true,
            queryFieldName: 'query'
        };

        return function(queryParamsNames, config) {
            var configuration = Object.assign({}, defaultConfiguration, config);
            return function(options, callback) {
                var queryParams = {},
                    bodyParams = {},
                    rawBatchItems,
                    endpoint,
                    typeParam;

                queryParams.key = utils.or(options.key, security.getKey('services/search'));

                rawBatchItems = utils.required(options.batchItems);
                typeParam = configuration.type ? configuration.type : options.type;

                bodyParams.batchItems = rawBatchItems.map(function(item) {
                    var pathParams = {}, itemParams = {}, query;
                    if (configuration.queryRequired) {
                        pathParams.query = utils.required(item[configuration.queryFieldName],
                            'Missing ' + configuration.queryFieldName + ' statement');
                    } else {
                        pathParams.query = '';
                    }
                    pathParams.type = typeParam ?
                        typeParam : utils.required(item.type, 'Missing type definition');
                    pathParams.contentType = 'json';

                    utils.extractQueryParams(item, itemParams, queryParamsNames);
                    itemParams.language = utils.or(item.language, options.language || 'en-GB');

                    query = urlBuilder(endpoints.batchSearchQuery, pathParams, itemParams);

                    return {query: query};
                });

                endpoint = bodyParams.batchItems.length <= maxNoOfItemsForSyncBatchRequest ? endpoints.batchSyncSearch :
                    endpoints.batchSearch;

                http.post({
                    url: '{protocol}://' + endpoint,
                    queryParameters: queryParams,
                    bodyParameters: bodyParams,
                    callbackParam: 'callback',
                    callback: callback,
                    fail: options.fail
                });
            };
        };
    });



// WEBPACK FOOTER //
// ./rest/batchSearch.js